import {combineReducers} from "redux";
import leftSideBarReducer from "./leftSideBarReducer";
import partnerBillingDataReducer from "./partnerBillingDataReducer";
import passMatchedReducer from "./passMatchedReducer";
import selectedComponentReducer from "./selectedComponentReducer";
import partnerAccountsReducer from "./partnerAccountsReducer";
import partnerDetailsReducer from "./partnerDetailsReducer";
import partnerInvoicesReducer from "./partnerInvoicesReducer";
import partnerProfileInfoUpdateStateReducer from "./partnerProfileInfoUpadateStateReducer";
import partnerCreditCardInfoReducer from "./partnerCreditCardInfoReducer";
import partnerCreditCardUpdateStateReducer from "./partnerCreditCardUpdateStateReducer";
import partnerBankInfoReducer from "./partnerBankInfoReducer";
import signingUpStateReducer from "./signingUpStateReducer";
import referralLinkReducer from "./referralLinkReducer";
import thirdPartyBillingReducer from "./thirdPartyBillingReducer";
import storeUsageMonthReducer from "./storeUsageMonthReducer";
import magicLinkReducer from "./magicLinkReducer";
import achBankInfoReducer from "./achBankInfoReducer";
import clientSecretReducer from "./clientSecretReducer";
import apiResponseMessagesReducer from "./apiResponseMessagesReducer";
import payoutBankInfoReducer from "./payoutBankInfoReducer";
import paypalApprovalReducer from "./paypalApprovalReducer";
import paypalInfoReducer from "./paypalInfoReducer";
import paypalIdentityReducer from "./paypalIdentityReducer";
import paypalIdentityConnectReducer from "./paypalIdentityConnectReducer";
import lastMonthBillingReducer from "./lastMonthBillingReducer";
import otpReducer from "./otpReducer";
import partnerActiveStoreMapping from "./partnerActiveReducer";
import partnerPayoutsStoreMapping from "./payoutsReducer";

export default combineReducers({
    leftSideBarActive: leftSideBarReducer,
    partnerBillingData: partnerBillingDataReducer,
    passMatched: passMatchedReducer,
    selectedComponent: selectedComponentReducer,
    partnerAccounts: partnerAccountsReducer,
    partnerDetails: partnerDetailsReducer,
    partnerInvoices: partnerInvoicesReducer,
    partnerProfileInfoUpdateState: partnerProfileInfoUpdateStateReducer,
    partnerCreditCardInfo: partnerCreditCardInfoReducer,
    partnerCreditCardUpdateState: partnerCreditCardUpdateStateReducer,
    partnerBankInfo: partnerBankInfoReducer,
    signingUpState: signingUpStateReducer,
    referralLink: referralLinkReducer,
    thirdPartyBillingDetails: thirdPartyBillingReducer,
    storeUsageMonth: storeUsageMonthReducer,
    magicLink: magicLinkReducer,
    achBankInfo: achBankInfoReducer,
    clientSecret: clientSecretReducer,
    apiResponseMessages: apiResponseMessagesReducer,
    payoutBankInfo: payoutBankInfoReducer,
    paypalApproval: paypalApprovalReducer,
    paypalInfo: paypalInfoReducer,
    paypalIdentity: paypalIdentityReducer,
    paypalIdentityConnected: paypalIdentityConnectReducer,
    lastMonthBilling: lastMonthBillingReducer,
    otp: otpReducer,
    ...partnerActiveStoreMapping,
    ...partnerPayoutsStoreMapping
});
